import { render, staticRenderFns } from "./CollegePrepAlabama.vue?vue&type=template&id=3501f812"
import script from "./CollegePrepAlabama.vue?vue&type=script&lang=ts"
export * from "./CollegePrepAlabama.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports